<template>
  <div :class="[{ 'hide': !show }, 'mobile__filters__container']">
    <div class="mobile__filters__heading">
      <div class="mobile__filters__heading-title">
        <span>Filtros</span>
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.20701 12.5H18.007M4.80701 7.69995H20.407M10.807 17.3H14.407" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <button @click="onChange(false)" class="btn__close">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25.3334 6.66669L6.66675 25.3334M25.3334 25.3334L6.66675 6.66669" stroke="#6BEDAD" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
    <div class="mobile__filters__actions">
      <div class="mobile__filters__actions-action">
        <button class="mobile__filter__action" data-toggle="collapse" href="#collapseLocation" aria-expanded="false" aria-controls="collapseLocation">
          <div class="mobile__filter__labels">
            <span class="mobile__filter__label">Selecciona locación</span>
            <span class="mobile__filter__value">Todas</span>
          </div>
          <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.5282 13.6085L19.9059 12.1821L15.6071 15.9615L11.3083 12.1821L9.68594 13.6085L15.6071 18.8179L21.5282 13.6085Z" fill="#9747FF" stroke-width="3" />
          </svg>
        </button>
        <div class="collapse" id="collapseLocation">
          <div class="filter__options">
            <button  class="filter__option-item active">Todos</button>
            <button v-for="(item, index) in locations" :key="index" class="filter__option-item">{{ item.attributes.name }}</button>
          </div>
        </div>
      </div>
      <div class="mobile__filters__actions-action">
        <button class="mobile__filter__action" data-toggle="collapse" href="#collapseProperty" aria-expanded="false" aria-controls="collapseProperty">
          <div class="mobile__filter__labels">
            <span class="mobile__filter__label">Tipo de propiedad</span>
            <span class="mobile__filter__value">Todas</span>
          </div>
          <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.5282 13.6085L19.9059 12.1821L15.6071 15.9615L11.3083 12.1821L9.68594 13.6085L15.6071 18.8179L21.5282 13.6085Z" fill="#9747FF" stroke-width="3" />
          </svg>
        </button>
        <div class="collapse" id="collapseProperty">
          <div class="filter__options">
            <button @click="propertyTypeSelect(0, 'Todas')" :class="selectedPropertyType === 0 ? 'filter__option-item active':'filter__option-item'" >All properties</button>
            <button @click="propertyTypeSelect(item.id, item.attributes.name)" v-for="(item, index) in propertyTypes" :key="index" :class="selectedPropertyType === item.id ? 'filter__option-item active':'filter__option-item'" >{{ item.attributes.name }}</button>
          </div>
        </div>
      </div>
      <div class="mobile__filters__actions-action">
        <button class="mobile__filter__action" data-toggle="collapse" href="#collapseCurrentCash" aria-expanded="false" aria-controls="collapseCurrentCash">
          <div class="mobile__filter__labels">
            <span class="mobile__filter__label">Retorno anual actual</span>
            <span class="mobile__filter__value">{{currentCashValue}}%</span>
          </div>
          <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.5282 13.6085L19.9059 12.1821L15.6071 15.9615L11.3083 12.1821L9.68594 13.6085L15.6071 18.8179L21.5282 13.6085Z" fill="#9747FF" stroke-width="3" />
          </svg>
        </button>
        <div class="collapse" id="collapseCurrentCash">
          <div class="filter__options">
            <slider v-model="currentCashValue" />
          </div>
        </div>
      </div>
      <div class="mobile__filters__actions-action">
        <button class="mobile__filter__action" data-toggle="collapse" href="#collapseCurrentIRR" aria-expanded="false" aria-controls="collapseCurrentIRR">
          <div class="mobile__filter__labels">
            <span class="mobile__filter__label">TIR actual Proyectada</span>
            <span class="mobile__filter__value">{{currentIRR}}%</span>
          </div>
          <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.5282 13.6085L19.9059 12.1821L15.6071 15.9615L11.3083 12.1821L9.68594 13.6085L15.6071 18.8179L21.5282 13.6085Z" fill="#9747FF" stroke-width="3" />
          </svg>
        </button>
        <div class="collapse" id="collapseCurrentIRR">
          <div class="filter__options">
            <slider v-model="currentIRR" />
          </div>
        </div>
      </div>
      <div class="mobile__filters__actions-action">
        <button class="mobile__filter__action" data-toggle="collapse" href="#collapseOrder" aria-expanded="false" aria-controls="collapseOrder">
          <div class="mobile__filter__labels">
            <span class="mobile__filter__label">Orden</span>
            <span class="mobile__filter__value">Todos</span>
          </div>
          <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.5282 13.6085L19.9059 12.1821L15.6071 15.9615L11.3083 12.1821L9.68594 13.6085L15.6071 18.8179L21.5282 13.6085Z" fill="#9747FF" stroke-width="3" />
          </svg>
        </button>
        <div class="collapse" id="collapseOrder">
          <div class="filter__options">
            <div class="filter__options">
              <button class="filter__option-item active">Muestra todos</button>
              <button class="filter__option-item">Nuevos</button>
              <button class="filter__option-item">Próximos</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Slider from '@/components/Slider.vue';
export default {
  name: 'MobileFilters',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    locations: {
      type: Array,
      required: true,
      default:{}
    },
    propertyTypes: {
      type: Array,
      required: true,
      default:{}
    },
    CoC: {
      type: Array,
      required: true,
      default:{}
    },
    IRR: {
      type: Array,
      required: true,
      default:{}
    },
  },
  data() {
    return {
      selectedOrder:0,
      selectedCash:0,
      selectedProjected:0,
      locationName:"All markets",
      propertyName:"All properties",
      currentCashValue:0,
      currentIRR: 0,
      selectedLocation:0,
      selectedPropertyType:0,
    };
  },
  methods: {
    locationSelect(item, name) {
      console.log("item",item)
      this.selectedLocation = item
      this.locationName = name
      this.$emit('on-change', this.selectedLocation, this.selectedPropertyType, this.selectedProjected, this.selectedCash)
    },
    propertyTypeSelect(item, name){
      console.log(item)
      this.propertyName = name
      this.selectedPropertyType = item
      this.$emit('on-change', this.selectedLocation, this.selectedPropertyType, this.selectedProjected, this.selectedCash)
    },
    projectedSelect(item){
      console.log(item)
      this.selectedProjected = item
      this.$emit('on-change', this.selectedLocation, this.selectedPropertyType, this.selectedProjected, this.selectedCash)
    },
    orderSelect(item){
      console.log(item)
      this.selectedOrder = item
      //this.$emit('on-change', this.selectedLocation, this.selectedPropertyType)
    },
    cashSelect(item){
      console.log(item)
      this.selectedCash = item
      this.$emit('on-change', this.selectedLocation, this.selectedPropertyType, this.selectedProjected, this.selectedCash)
    },
    onChange(value) {
      this.$emit('hide', value)
    },
  },
  components: {
    Slider,
  },
}
</script>
<style lang="scss">
.mobile__filters__container {
  position: fixed;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background: red;
  top: 0;
  right: 0;
  z-index: 9999;
  background-color: #120427;
  animation: fadeInAnimation ease-in-out 0.5s forwards;
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.btn__close {
  all: unset;
}

.hide {
  opacity: 0;
  visibility: hidden;
  animation: fadeOutAnimation ease-out 0.5s forwards;
}

.filter__options {
  justify-content: flex-end;
}

.mobile__filters__actions {
  display: flex;
  flex-direction: column;
  gap: 28px;
  margin-top: 36px;

  .mobile__filters__actions-action {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .mobile__filter__action {
      all: unset;
      display: flex;
      align-items: center;
      gap: 6px;
      justify-content: flex-end;
    }
    .mobile__filter__labels {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;

      .mobile__filter__label {
        font-size: 16px;
        font-family: 'Montserrat', sans-serif;
        color: white;
      }

      .mobile__filter__value {
        font-size: 12px;
        font-family: 'Roboto', sans-serif;
        color: #9AEEC5;
      }
    }
  }
}

@keyframes fadeInAnimation {
  0% {
    opacity: 0;
    visibility: hidden;
    max-width: 0px;
  }
  100% {
    opacity: 1;
    visibility: visible;
    max-width: 100%;
  }
}

.mobile__filters__heading {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .mobile__filters__heading-title {
    font-size: 20px;
    color: white;
  }

  svg {
    color: #D6C1F5;
  }
}

@keyframes fadeOutAnimation {
  0% {
    opacity: 1;
    max-width: 100%;
    visibility: visible;
  }
  100% {
    opacity: 0;
    max-width: 0px;
    visibility: hidden;
  }
}

@media (min-width: 992px) {
  .mobile__filters__container {
    display: none;
  }
}
</style>